import React from 'react';
import { View } from 'react-native';
import Svg, { Line } from 'react-native-svg';
import Amount from 'design-system/Amount';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const STROKE_WIDTH = 1;
const SVG_HEIGHT = STROKE_WIDTH + 2;
export const LevelLine = ({ currencyAmount, width, height, y, showBackground }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    return (<View pointerEvents="none" style={[styles.absolute, { top: y * height, left: 0 }]}>
      <Svg width={width} height={SVG_HEIGHT} viewBox={`0 0 ${width} ${STROKE_WIDTH}`}>
        <Line x1="100%" y1="0" x2="0" y2="0" stroke={colors.elements.secondary} strokeWidth={STROKE_WIDTH} strokeDasharray="1, 5"/>
      </Svg>
      <View style={[
            styles.absolute,
            styles.amountAboveLine,
            showBackground && styles.amountAboveLineBackground,
        ]}>
        <Amount NumbersThin-12 Secondary value={currencyAmount}/>
      </View>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    absolute: {
        position: 'absolute',
    },
    amountAboveLine: {
        bottom: SVG_HEIGHT,
        marginLeft: rem(8),
        marginBottom: rem(6),
        borderRadius: rem(4),
    },
    amountAboveLineBackground: {
        paddingHorizontal: rem(6),
        paddingVertical: rem(4),
        backgroundColor: `${colors.background.dark}D9`,
    },
}));
